import React from 'react';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core';

const AppTheme = ({ children }) => {
  let theme = createTheme({
    palette: {
      primary: {
        main: '#c0f',
        contrastText: '#000'
      }
    },
    typography: {
      fontFamily: '"Source Sans Pro", "Open Sans"',
    h1: {
      fontFamily: 'Source Sans Pro'
    },
    h2: {
      fontFamily: 'Source Sans Pro'
    },
    h3: {
      fontFamily: 'Source Sans Pro'
    },
    h4: {
      fontFamily: 'Source Sans Pro'
    },
    h5: {
      fontFamily: 'Source Sans Pro'
    },
    h6: {
      fontFamily: 'Source Sans Pro'
    },
    subtitle1: {
      fontFamily: 'Open Sans'
    },
    subtitle2: {
      fontFamily: 'Open Sans'
    },
    body1: {
      fontFamily: 'Open Sans'
    },
    body2: {
      fontFamily: 'Open Sans'
    },
    button: {
      fontFamily: 'Open Sans'
    },
    caption: {
      fontFamily: 'Open Sans'
    },
    overline: {
      fontFamily: 'Open Sans'
    }
    }
  })

  theme = responsiveFontSizes(theme)

  return (
    <ThemeProvider theme={theme}>
      { children }
    </ThemeProvider>
  )
}

export default AppTheme;